var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "auth-card relative-position" },
    [
      _c("q-card-main", [
        _c("h1", { staticClass: "text-center auth-card__heading" }, [
          _vm._v(_vm._s(_vm.$t("tfa_heading")))
        ]),
        _c("p", { staticClass: "text-center auth-card__description" }, [
          _vm._v(_vm._s(_vm.$t("tfa_description")))
        ]),
        _c(
          "form",
          {
            attrs: { id: "login-form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleLogin($event)
              }
            }
          },
          [
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.errors.has("otpCode"),
                  "error-label": _vm.errors.first("otpCode")
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    }
                  ],
                  ref: "otpCode",
                  attrs: {
                    name: "otpCode",
                    "float-label": _vm.$t("otp_code"),
                    required: "",
                    autofocus: ""
                  },
                  model: {
                    value: _vm.verificationCode,
                    callback: function($$v) {
                      _vm.verificationCode = $$v
                    },
                    expression: "verificationCode"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "auth-card__footer row justify-end" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-auto col-xs-12 self-center auth-card__primary-action"
                },
                [
                  _c("q-btn", { attrs: { type: "submit", color: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("login")))
                  ])
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _c("q-inner-loading", { attrs: { visible: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }